


import React, { useState } from "react";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import PageContainer from "../components/pages/PageContainer";
import DashboardHeader from "../components/Other/DashboardHeader";

const BeforeSearch = () => {
  const isMobileView = document.body.clientWidth <= 768;
  return (

    <>
      <DashboardHeader  />
      <PageHeaderTitle title={("Change Password")} />
      <PageContainer>
        <div
        >
           <h1 className="text-2xl font-bold mb-4">Please search for a stock to create an order.</h1>
        </div>
      </PageContainer>
    </>

  )
}

export default BeforeSearch
